export const QUERYKEY_AMENITIES = "amenities";
export const QUERYKEY_AIRLINES = "airlines";
export const QUERYKEY_APPROVAL_BY_ID = "approvalById";
export const QUERYKEY_APPROVAL_DELEGATIONS = "approvalDelegations";
export const QUERYKEY_APPROVALS = "approvals";
export const QUERYKEY_BUSINESS_INTELLIGENCE = "businessIntelligence";
export const QUERYKEY_CAROUSEL = "carousel";
export const QUERYKEY_CHECK_IMPERSONATION = "checkImpersonation";
export const QUERYKEY_FAREFORECASTER = "fareForecaster";
export const QUERYKEY_FAREFORECASTER_GRAPH = "fareForecasterGraph";
export const QUERYKEY_LIGHTNING_COMPANY_REFERENCE_LIST_ITEMS =
  "lightningCompanyReferenceListItems";
export const QUERYKEY_LIGHTNING_SETTINGS = "lightningSettings";
export const QUERYKEY_LIGHTNING_DEPARTMENTS = "lightningDepartments";
export const QUERYKEY_LIGHTNING_COST_CENTERS = "lightningCostCenters";
export const QUERYKEY_LIGHTNING_TRAVELERS = "lightningTravelers";
export const QUERYKEY_FEATURE = "feature";
export const QUERYKEY_PROVISIONAL_TRAVELERS = "provisionalTravelers";
export const QUERYKEY_UNUSED_TICKETS = "unusedTickets";
export const QUERYKEY_UPCOMING_TRIPS = "upcomingTrips";
export const QUERYKEY_UPCOMING_TRIP_ITINERARY = "upcomingTripItinerary";
